import { useState } from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import {
  Box,
  Stack
} from '@chakra-ui/react'
import {
  authSelectors,
  handleOpenModal,
  markersSelectors,
  setBlogParent,
  setComments,
  setConnReqData,
  setHideNotification,
  setNotificationSectionPage,
  setOpenFriendRequest,
  setPosts,
  stopMap,
  usersSelectors,
  chatCredentialsSelectors,
  getAdminNotifications,
  getBlockedRequest,
  getFriendsNotifications,
  setAdminNotifRequest,
  setUserSectionPage,
  setBlogRepostData,
  setChatSectionPage,
  setOpenPopupBlogs,
  setOpenPopupEvents
} from 'store'
import {
  MODAL_SECTION,
  NotificationSections,
  SUCCEEDED
} from 'utils/constants'
import {
  isAuth,
  showCoordParams
} from 'utils/helpers'
import { COLORS } from 'utils/styles'

import { NotifBarDisplay } from 'components/Footer/NotifBarDisplay'
import { NotificationPanel } from './NotificationPanel'

export const Footer = () => {
  const { mapStop } = useSelector(markersSelectors)
  const { signInStatus } = useSelector(authSelectors)
  const {
    meXmppIsOnline,
    meXmppProblem
  } = useSelector(chatCredentialsSelectors)
  const {
    notificationSectionPage,
    activeProfile,
    getBlockedRequestStatus,
    getFriendsNotificationsStatus,
    getAdminNotificationsStatus
  } = useSelector(usersSelectors)

  const dispatch = useDispatch()

  const [showNotifications, setShowNotifications] = useState(false)
  const [runClosingAnimation, setRunClosingAnimation] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()

  const clearOptions = (isNotifModalOpen) => {
    if (!isNotifModalOpen) {
      dispatch(setOpenFriendRequest(null))
    }

    dispatch(setConnReqData([]))
    sessionStorage.removeItem('id')
    localStorage.removeItem('openedNotifId')
    localStorage.setItem('is-notif-modal-open', 'false')
    dispatch(handleOpenModal({ isOpen: isNotifModalOpen, section: MODAL_SECTION?.RightSection }))
    setSearchParams({})

    dispatch(setHideNotification(false))
    setRunClosingAnimation(!isNotifModalOpen)
    if (!isNotifModalOpen) {
      dispatch(setNotificationSectionPage('clear'))
      showCoordParams(setSearchParams)
    }
  }

  return (
    <Stack
      position="relative"
      background={COLORS.gold}
      width="100%"
      height="50px"
      className="notificationBar"
      data-name="notificationBar"
    >
      <Box
        position="absolute"
        zIndex={isAuth() ? 1401 : 1392}
        display="flex"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        cursor="pointer"
        id="open-notif-panel"
        onClick={() => {
          sessionStorage.removeItem('openProfileAfterAnimation')
          sessionStorage.removeItem('openEventAfterAnimation')
          document.querySelector('#custom-popup-overlay')?.click()
          document.querySelector('#custom-popup-overlay-event')?.click()
          dispatch(setUserSectionPage('clear'))
          dispatch(setChatSectionPage('clear'))
          dispatch(setNotificationSectionPage('clear'))
          dispatch(setOpenPopupBlogs(false))
          dispatch(setOpenPopupEvents(false))
          dispatch(setBlogRepostData([]))
          dispatch(setHideNotification(false))

          dispatch(setNotificationSectionPage({
            key: NotificationSections.NOTIFICATIONS,
            title: 'Notifications'
          }))

          if (
            meXmppIsOnline
            || meXmppProblem != null
          ) {
            dispatch(setAdminNotifRequest(null))

            if (getAdminNotificationsStatus !== 'PENDING') {
              dispatch(getAdminNotifications()).then(() => setShowNotifications(true))
            }

            if (getFriendsNotificationsStatus !== 'PENDING') {
              dispatch(getFriendsNotifications())
            }

            if (getBlockedRequestStatus !== 'PENDING') {
              dispatch(getBlockedRequest(activeProfile?.id))
            }
          }

          dispatch(stopMap(!mapStop))
          dispatch(setConnReqData([]))
          dispatch(setBlogParent([]))
          dispatch(setPosts([]))
          dispatch(setComments([]))
          localStorage.setItem('isNotifOpen', 'true')
          clearOptions(true)
        }}
      >
        {
          isAuth()
            ? <NotifBarDisplay notificationSectionPage={notificationSectionPage} />
            : (
              <Box
                as="button"
                height="40px"
                padding="10px 61px"
                borderRadius="5px"
                backgroundColor="white"
                width="366px"
                fontSize="20px"
                lineHeight="22.5px"
                boxShadow="0 3px 3px 0 rgba(108, 122, 137, .7)"
                sx={{
                  '@media (max-width: 768px)': {
                    width: '385px'
                  },
                  '@media (max-width: 480px)': {
                    width: '306px',
                    fontSize: '15px'
                  },
                  '@media (max-width: 390px)': {
                    width: '266px',
                    padding: '10px 45px',
                    fontSize: '15px'
                  }
                }}
              >
                <center>
                  {
                    sessionStorage.getItem('postId')
                    && signInStatus !== SUCCEEDED
                    && !isAuth()
                      ? 'Get Connected! Sign Up...'
                      : 'Instructions'
                  }
                </center>
              </Box>
            )
        }
      </Box>

      <NotificationPanel
        runClosingAnimation={runClosingAnimation}
        clearOptions={clearOptions}
        setShowNotifications={setShowNotifications}
        showNotifications={showNotifications}
      />
    </Stack>
  )
}
